module.exports = __webpack_public_path__ + "static/media/7. Materia orgánica, Mixta sobre cartón pluma, 35 x 50 cm, 2012 copy.0e62d37e.png";